export default __webpack_public_path__ + "static/media/logo-cl-black.65d9ae72.svg";